import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import phBehance from "../../../assets/images/blurred2/jobs/behance.webp";
import phDesignHill from "../../../assets/images/blurred2/jobs/designhill.webp";
import phFivver from "../../../assets/images/blurred2/jobs/fivver.webp";
import phFlexJobs from "../../../assets/images/blurred2/jobs/flexjobs.webp";
import phFreelancer from "../../../assets/images/blurred2/jobs/freelancer.webp";
import phGuru from "../../../assets/images/blurred2/jobs/guru.webp";
import phLinkedIn from "../../../assets/images/blurred2/jobs/linkedIn.webp";
import phToptal from "../../../assets/images/blurred2/jobs/toptal.webp";
import phUpwork from "../../../assets/images/blurred2/jobs/upwork.webp";
import phWWR from "../../../assets/images/blurred2/jobs/wwr.webp";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, isValidArray, nextPageRoute } from "../../../utils/modules";
const imagesToPreload = {
  male: [
    "/imoji/star_struk.png",
    "/staging/male/lower_shadow_male.jpg",
    "/imoji/thumb_up_1.png",
  ],
  female: [
    "/imoji/star_struk.png",
    "/staging/female/lower_shadow_female.jpg",
    "/imoji/thumb_up_1.png",
  ],
};

const Platforms = () => {
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const navigate = useNavigate();
  const params = useParams();
  const gender = params.gender || "female";
  const dispatch = useDispatch();

  const togglePlatformSelection = (platform) => {
    if (selectedPlatforms.includes(platform)) {
      setSelectedPlatforms(
        selectedPlatforms.filter(
          (selectedPlatform) => selectedPlatform !== platform
        )
      );
    } else {
      setSelectedPlatforms([...selectedPlatforms, platform]);
    }
  };

  const isSelected = (platform) => {
    return selectedPlatforms.includes(platform)
      ? "job-selected-button"
      : "job-select-button";
  };

  return (
    <MobileViewLayout>
      <div className="flex-grow-1 d-flex flex-column align-content-center justify-content-start position-relative px-3">
        <div
          className="d-flex flex-column justify-content-center w-100 px-2 pb-2 age-selection-heading"
          style={{ paddingTop: "68px" }}
        >
          <h1 className="fs30 text-center fw-bolder age-selection-heading pt-0 m-0 pb-0 travel-heading jobs-heading">
            <Trans i18nKey={"freelance_platforms.question"} />
          </h1>
          <div
            className="d-flex flex-column gap-3"
            style={{ paddingTop: "50px" }}
          >
            <div className="d-flex flex-row w-100 justify-content-center gap-3 pb-2">
              <div
                className={`rounded-2 ${isSelected("Freelancer")}`}
                onClick={() => togglePlatformSelection("Freelancer")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    src={addS3Url("/jobs/freelancer.png")}
                    placeHolderImage={phFreelancer}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.freelancer"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("LinkedIn")}`}
                onClick={() => togglePlatformSelection("LinkedIn")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phLinkedIn}
                    src={addS3Url("/jobs/linkedIn.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.linkedin"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3 pb-2 ">
              <div
                className={`rounded-2 ${isSelected(
                  "Fiverr"
                )} d-flex justify-content-center align-items-center`}
                onClick={() => togglePlatformSelection("Fiverr")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phFivver}
                    src={addS3Url("/jobs/fivver.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.fiverr"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected(
                  "Guru"
                )} d-flex justify-content-center align-items-center`}
                onClick={() => togglePlatformSelection("Guru")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phGuru}
                    src={addS3Url("/jobs/guru.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.guru"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Toptal")}`}
                onClick={() => togglePlatformSelection("Toptal")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phToptal}
                    src={addS3Url("/jobs/toptal.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.toptal"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3 pb-2 ">
              <div
                className={`rounded-2 ${isSelected("Upwork")}`}
                onClick={() => togglePlatformSelection("Upwork")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phUpwork}
                    src={addS3Url("/jobs/upwork.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.upwork"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Designhill")}`}
                onClick={() => togglePlatformSelection("Designhill")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phDesignHill}
                    src={addS3Url("/jobs/designhill.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.designhill"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3 pb-2">
              <div
                className={`rounded-2 ${isSelected("Flexjobs")}`}
                onClick={() => togglePlatformSelection("Flexjobs")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phFlexJobs}
                    src={addS3Url("/jobs/flexjobs.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.flexjobs"} />
                </p>
              </div>
              <div
                className={`rounded-2 ${isSelected("Behance")}`}
                onClick={() => togglePlatformSelection("Behance")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phBehance}
                    src={addS3Url("/jobs/behance.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.behance"} />
                </p>
              </div>
            </div>
            <div className="d-flex flex-row w-100 justify-content-center gap-3">
              <div
                className={`rounded-2 ${isSelected("WWR")}`}
                onClick={() => togglePlatformSelection("WWR")}
              >
                <p
                  className="text-center m-0 d-flex flex-row align-items-center fs18"
                  style={{ fontWeight: 700 }}
                >
                  <ImageLoader
                    style={{ minWidth: "10px" }}
                    placeHolderImage={phWWR}
                    src={addS3Url("/jobs/wwr.png")}
                    className="platform-img"
                    alt="freelancer"
                  />
                  <Trans i18nKey={"freelance_platforms.wwr"} />
                </p>
              </div>
            </div>
          </div>
          <Button
            onClick={() =>
              isValidArray(selectedPlatforms) &&
              nextPageRoute(
                navigate,
                `/${params.gender}/profileSummary`,
                dispatch,
                imagesToPreload[gender]
              )
            }
            className="w-100 fw-bold mb-3 fs18 bgSecondary sticky-button text-capitalize"
            style={{ marginTop: "45px", padding: "10px 0px", height: "60px" }}
          >
            <Trans i18nKey={"common_text.continue"} />
          </Button>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default Platforms;
